module.exports = __webpack_public_path__ + "assets/550bd1a433b65324ebc4f83adf16ab87.mp3";